import gCard from "@/components/g-card/g-card.vue"
import { useVuelidate } from "@vuelidate/core";
import { helpers, required, sameAs, minLength } from "@vuelidate/validators";
import gValidators from "@/shared/custom/validators/g-validators";

export default {
  name:'ForgotPassword',
  components:{
    'g-card': gCard
  },
  data () {
    return {
      dataNewPassWord: {
        token: "",
        email: "",
        newPassword: "",
        confirmanewPassword: "",
      },
      mensagem: '', 
      labelBotao: 'SALVAR',
      estaCarregando: false,
      tipo: 'password',
      tipoConfirma: 'password',
      tamanhoBotao: '60%',
      login: '',
      senha: '',
      senhaConfirma: '',
      submit: false,
    }
  },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  validations() {
    return {
      dataNewPassWord: {
        newPassword: {
          required: helpers.withMessage(
            "O campo senha é obrigatorio!",
            required
          ),
          minLength: helpers.withMessage( `Sua senha precisa ter no mínimo 6 caracteres`, minLength(6)),
          contemEspeciais: helpers.withMessage( `Sua senha precisa ter caracteres especiais`, gValidators.contemEspeciais),
          contemMinusculas: helpers.withMessage( `Sua senha precisa ter alguma letra maiúscula`, gValidators.contemMinusculas),
          contemMaiuscula: helpers.withMessage( `Sua senha precisa ter alguma letra minúscula`, gValidators.contemMaiuscula),
          contemNumero: helpers.withMessage( `Sua senha precisa ter números`, gValidators.contemNumero),
        },
        confirmanewPassword: {
          required: helpers.withMessage(
            "O campo Confirmar senha é obrigatorio!",
            required
          ),
          sameAsPassword: helpers.withMessage(
            "Ambas as senhas tem que ser iguais!",
            sameAs(this.dataNewPassWord.newPassword)
          ),
        },
      },
    };
  },
 mounted () {
     const UrlParams = new URLSearchParams(window.location.search);
      const token = UrlParams.get("t");
  this.dataNewPassWord.token = token.split("?Login=")[0]
  this.dataNewPassWord.email = token.split("?Login=")[1];
  this.dataNewPassWord.email = this.dataNewPassWord.email.trim();
 },
  methods:{
    ResetPassword() {
      this.submit = true;
      if (this.v$.$invalid) {
        this.v$.$silentErrors.forEach((error) => {
          this.$toast.add({
            severity: "error",
            summary: "ERRO",
            detail: error.$message,
            life: 5000,
          });
        });
        return;
      }
      this.$store.state.loading = true;
      this.axios({
        method: "post",
        data: this.dataNewPassWord,
        url:
          process.env.VUE_APP_WEB_API +
          'ResetPassword',
      }).then((Response) => {
        this.$store.state.loading = false;
        if (Response.data.code === 200) {  
        
          this.$toast.add({
            severity: "success",
            summary: "Senha Alterada",
            detail: "Senha Alterada com sucesso!!",
            life: 5000,
          })
          setTimeout(()=>{
            this.$router.push("/dashboard")
          }, 2000);
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Erro ao Alterar",
            detail: Response.data.mensagem,
            life: 5000,
          });
        }
      });
    },
    mostrarSenha(){
      if(this.tipo=== 'password'){
        this.tipo = 'text'
      }
      else{
        this.tipo = 'password'
      }
    },
    mostrarSenhaConfirma(){
      if(this.tipoConfirma=== 'password'){
        this.tipoConfirma = 'text'
      }
      else{
        this.tipoConfirma = 'password'
      }
    },
    salvarSenha() {
      if(this.dataNewPassWord.newPassword == this.dataNewPassWord.confirmanewPassword) {
        this.ResetPassword()
      }
      else {
        this.$toast.add({ severity: 'error', summary: 'ERRO', detail: 'As senhas não coincidem!', life: 5000 })
      }
    }
  }
}